import React, { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import { api, formatGYD } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Star } from "@phosphor-icons/react";

export default function HistoryPage() {
  const { user } = useAuth();
  const [rides, setRides] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/rides/history");
        setRides(data);
      } catch {}
    })();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar active={user?.role === "driver" ? "trips" : "history"} />
      <div className="max-w-[1100px] mx-auto px-6 py-10">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-foreground/60">
          {user?.role === "driver" ? "Trips" : "Ride history"}
        </div>
        <h1 className="font-display text-4xl tracking-tighter mb-8">Past rides</h1>

        <div className="space-y-3">
          {rides.map((r) => (
            <div key={r.ride_id} className="border-2 border-foreground p-4 grid grid-cols-1 md:grid-cols-12 gap-4 bg-card" data-testid={`history-row-${r.ride_id}`}>
              <div className="md:col-span-2 font-mono text-xs uppercase tracking-wider text-foreground/60">
                {(r.created_at || "").slice(0, 16).replace("T", " ")}
              </div>
              <div className="md:col-span-5 text-sm">
                <div><span className="text-foreground/60">From:</span> {r.pickup.address}</div>
                <div><span className="text-foreground/60">To:</span> {r.dropoff.address}</div>
              </div>
              <div className="md:col-span-2 font-mono text-sm">{r.distance_km} km</div>
              <div className="md:col-span-2 font-display text-xl">{formatGYD(r.fare_gyd)}</div>
              <div className="md:col-span-1 flex items-center">
                <span className="font-mono text-[10px] uppercase px-2 py-1 border-2 border-foreground">{r.status}</span>
              </div>
              {r.rating && (
                <div className="md:col-span-12 flex items-center gap-1 text-foreground/70 text-sm">
                  {[1,2,3,4,5].map(n => (
                    <Star key={n} size={14} weight={r.rating >= n ? "fill" : "regular"} className={r.rating >= n ? "text-primary" : ""} />
                  ))}
                  {r.review && <span className="ml-2 italic">"{r.review}"</span>}
                </div>
              )}
            </div>
          ))}
          {rides.length === 0 && (
            <div className="border-2 border-dashed border-foreground/30 p-8 text-center text-foreground/60">
              No rides yet.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
